import { combineReducers } from 'redux';

import ShowcaseTypes from './types';

export const showcaseReducer = combineReducers({
  getProducer: ShowcaseTypes.getProducer.getReducer(),
  getAffiliate: ShowcaseTypes.getAffiliate.getReducer(),
  getFresh: ShowcaseTypes.getFresh.getReducer(),
  getBestsellers: ShowcaseTypes.getBestsellers.getReducer(),
  getGeneral: ShowcaseTypes.getGeneral.getReducer(),
  getPhysical: ShowcaseTypes.getPhysical.getReducer(),
  showProduct: ShowcaseTypes.showProduct.getReducer(),
  listAdvertisementMaterial: ShowcaseTypes.listAdvertisementMaterial.getReducer(),
  listShowcaseQuestions: ShowcaseTypes.listShowcaseQuestions.getReducer(),
  askQuestion: ShowcaseTypes.askQuestion.getReducer(),
  allRatingsShowcase: ShowcaseTypes.allRatingsShowcase.getReducer(),
  ratingShowcase: ShowcaseTypes.ratingShowcase.getReducer(),
  createAffiliate: ShowcaseTypes.createAffiliate.getReducer(),
  showcaseProfile: ShowcaseTypes.showcaseProfile.getReducer(),
  rateProducer: ShowcaseTypes.rateProducer.getReducer(),
  getSubscriptions: ShowcaseTypes.getSubscriptions.getReducer(),
});
